module.exports = {"430182001":"玉潭街道","430182002":"白马桥街道","430182003":"历经铺街道","430182004":"城郊街道","430182101":"道林镇","430182102":"花明楼镇","430182103":"东湖塘镇","430182104":"夏铎铺镇","430182105":"双江口镇","430182106":"煤炭坝镇","430182107":"坝塘镇","430182109":"灰汤镇","430182110":"双凫铺镇","430182111":"老粮仓镇","430182112":"流沙河镇","430182113":"巷子口镇","430182114":"龙田镇","430182116":"横市镇","430182117":"回龙铺镇","430182118":"黄材镇","430182119":"大成桥镇","430182120":"青山桥镇","430182121":"金洲镇","430182122":"大屯营镇","430182123":"资福镇","430182203":"菁华铺乡","430182209":"喻家坳乡","430182213":"沙田乡","430182218":"沩山乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/430182.json
// module id = 1813
// module chunks = 0